import { createAction } from 'redux-actions';
export const SET_EVERY_TRAVEL_CART = 'SET_EVERY_TRAVEL_CART';
export const setEveryTravelCartIdAction = createAction(SET_EVERY_TRAVEL_CART);
